module.exports = __webpack_public_path__ + "static/media/skill-1.d86d38f9.svg";